export class MapConfig {
    public static mapPartHeight: number = 1300;
    public static elements = [
        {
            x: 810,
            y: 5320,
            isRevard: false,
            level: 1,
        },
        {
            x: 600,
            y: 5090,
            isRevard: false,
            level: 2,
        },
        {
            x: 900,
            y: 5090,
            isRevard: false,
            level: 3,
        },
        {
            x: 730,
            y: 4850,
            isRevard: false,
            level: 4,
        },
        {
            x: 540,
            y: 4700,
            isRevard: false,
            level: 5,
        },
        {
            x: 800,
            y: 4575,
            isRevard: false,
            level: 6,
        },
        {
            x: 1000,
            y: 4450,
            isRevard: false,
            level: 7,
        },
        {
            x: 800,
            y: 4250,
            isRevard: false,
            level: 8,
        },
        {
            x: 580,
            y: 4400,
            isRevard: false,
            level: 9,
        },
        {
            x: 350,
            y: 4250,
            isRevard: false,
            level: 10,
        },
        {
            x: 600,
            y: 4100,
            isRevard: false,
            level: 11,
        },
        {
            x: 850,
            y: 4000,
            isRevard: false,
            level: 12,
        },
        {
            x: 850,
            y: 3700,
            isRevard: false,
            level: 13,
        },
        {
            x: 600,
            y: 3780,
            isRevard: false,
            level: 14,
        },
        {
            x: 300,
            y: 3850,
            isRevard: false,
            level: 15,
        },
        {
            x: 300,
            y: 3500,
            isRevard: false,
            level: 16,
        },
        {
            x: 570,
            y: 3500,
            isRevard: false,
            level: 17,
        },
        {
            x: 850,
            y: 3425,
            isRevard: false,
            level: 18,
        },
        {
            x: 900,
            y: 3150,
            isRevard: false,
            level: 19,
        },
        {
            x: 600,
            y: 3150,
            isRevard: false,
            level: 20,
        },
        {
            x: 300,
            y: 3200,
            isRevard: false,
            level: 21,
        },
        {
            x: 300,
            y: 2980,
            isRevard: false,
            level: 22,
        },
        {
            x: 600,
            y: 2900,
            isRevard: false,
            level: 23,
        },
        {
            x: 900,
            y: 2860,
            isRevard: false,
            level: 24,
        },
        {
            x: 900,
            y: 2580,
            isRevard: false,
            level: 25,
        },
        {
            x: 600,
            y: 2600,
            isRevard: false,
            level: 26,
        },
        {
            x: 300,
            y: 2650,
            isRevard: false,
            level: 27,
        },
        {
            x: 300,
            y: 2350,
            isRevard: false,
            level: 28,
        },
        {
            x: 600,
            y: 2300,
            isRevard: false,
            level: 29,
        },
        {
            x: 900,
            y: 2200,
            isRevard: false,
            level: 30,
        },
    ]
}